import Api from ".";
import { showLoader, stopLoader } from "../redux/slices/generalSlice";
import ApiEndPoint from "./ApiEndpoint";
import { setRole } from "../redux/slices/userSlice";

export const getUserDetails = () => async (dispatch) => {
  try {
    // dispatch(showLoader());
    const url = `${ApiEndPoint.user}${ApiEndPoint.v1}`;
    const {
      data: { data },
    } = await Api.get(url);
    console.log("data of user", data);
    dispatch(setRole(data?.role));
    // dispatch(stopLoader());
    return true;
  } catch (e) {
    dispatch(stopLoader());
    return e.response;
  }
};

export default { getUserDetails };
